module.exports = __webpack_public_path__ + "h5/img/no-customer.e664fbb0.png";